import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';
import { formatCurrencyAmount } from '@/utils/currency.utils';

import { formatPaymentDate } from '../utils/channelPresentation';
import { isCancelledPaymentEntry } from '../utils/paymentEntryState';
import { buildPaymentSummaryLines } from '../utils/paymentSummary';

export default function PaymentSummaryDialog({ entry, onClose }) {
  return (
    <GenericPopup open={Boolean(entry)} onBackgroundClick={onClose} opacity className="generic-popup_content profile-payments__popup">
      <div className="generic-popup__header profile-payments__popup-header">
        <Text className="generic-popup__header-text profile-payments__popup-title ">Payment summary</Text>
        <XIcon className="generic-popup__close profile-payments__popup-close" onClick={onClose} />
      </div>
      <div className="profile-payments__summary-body">
        <Text className="profile-payments__summary-reference ">{entry?.orderNumber ? `Order #${entry.orderNumber}` : entry?.description}</Text>
        {buildPaymentSummaryLines(entry).map((line) => (
          <div key={`${line.label}-${line.amount}`} className="profile-payments__summary-line">
            <Text className={`${line.isTotal ? ' profile-payments__summary-total-label' : ''}`}>{line.label}</Text>
            <Text className={`${line.isTotal ? ' profile-payments__summary-total-value' : ''}`}>
              {formatCurrencyAmount(line.amount, line.currency, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </Text>
          </div>
        ))}
        {isCancelledPaymentEntry(entry) && (
          <div className="profile-payments__summary-cancellation">
            <Text className="">{`Cancellation date: ${entry?.cancellationDate ? formatPaymentDate(entry.cancellationDate) : 'Not available'}`}</Text>
            <Text className="">{`Cancellation reason: ${entry?.cancellationReason || 'Not provided'}`}</Text>
          </div>
        )}
      </div>
    </GenericPopup>
  );
}
